// Central site configuration. Values fall back to placeholders; in production
// these map to PUBLIC_* env vars consumed at build time (see .env.example).
export const SITE = {
  name: "R0AM by Wadiah Mutual",
  shortName: "R0AM",
  pronounced: "pronounced \u201cROAM\u201d",
  whatsapp: process.env.REACT_APP_PUBLIC_WHATSAPP_NUMBER || "+1-000-000-0000",
  email: process.env.REACT_APP_PUBLIC_CONTACT_EMAIL || "r0am@wadiahmutual.com",
  apiBase: process.env.REACT_APP_PUBLIC_MUTUALAUTOMATION_API_BASE || "",
  url: process.env.REACT_APP_PUBLIC_SITE_URL || "https://r0am.wadiahmutual.com",
  demoForms:
    (process.env.REACT_APP_PUBLIC_ENABLE_DEMO_FORMS || "true") !== "false",
};

export const whatsappLink = (msg = "Hi R0AM, I'd like assistance with my global mobility plan.") =>
  `https://wa.me/${SITE.whatsapp.replace(/[^0-9]/g, "")}?text=${encodeURIComponent(msg)}`;

// Future mutualautomation endpoints — forms POST here when apiBase is set.
export const ENDPOINTS = {
  leads: "/api/leads",
  quotes: "/api/quotes",
  partners: "/api/partners",
  newsletter: "/api/newsletter",
  smartbag: "/api/smartbag",
  connectivity: "/api/connectivity-waitlist",
  riskOptions: "/api/risk-options",
  telemedicine: "/api/telemedicine-interest",
  chatbotLeads: "/api/chatbot-leads",
  chatbotQuoteIntake: "/api/chatbot-quote-intake",
  hubspotSync: "/api/hubspot-sync",
};

export const IMAGES = {
  heroMap:
    "https://static.prod-images.emergentagent.com/jobs/aaadc17f-a467-4944-af42-c22d26a7f63c/images/f98f461cfa9e845248a913ac3c3c0e7c46d65ec2fe9b3bac198cea8e2e22e528.png",
  riskOps:
    "https://static.prod-images.emergentagent.com/jobs/aaadc17f-a467-4944-af42-c22d26a7f63c/images/aff709139313cb71d392697a88456ddf48676f65bfa0c4c8b14093aa03671f14.png",
  nomad:
    "https://images.pexels.com/photos/5992574/pexels-photo-5992574.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  executive:
    "https://images.pexels.com/photos/5778602/pexels-photo-5778602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  conference:
    "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  baggage:
    "https://images.unsplash.com/photo-1629308993023-bb7ca078abdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  telemedicine:
    "https://images.unsplash.com/photo-1758691463620-188ca7c1a04f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  connectivity:
    "https://images.pexels.com/photos/20805605/pexels-photo-20805605.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  family:
    "https://images.pexels.com/photos/37669246/pexels-photo-37669246.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  seasonal:
    "https://images.pexels.com/photos/7457195/pexels-photo-7457195.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV = [
  { label: "Plans", to: "/plans" },
  { label: "SmartBag", to: "/smartbag" },
  { label: "Telemedicine", to: "/telemedicine" },
  { label: "Connectivity", to: "/connectivity" },
  { label: "Risk Options", to: "/risk-options" },
  { label: "Traders", to: "/traders-conferences" },
  { label: "Partners", to: "/partners" },
];
